module.exports = __webpack_public_path__ + "34833f3ed3a8156ca5329409a9b579ee.svg";